export const REDUCER_NAME = 'search'




// WEBPACK FOOTER //
// ./src/modules/prospect/state/search/const.js